import React, { ChangeEvent, ReactNode } from 'react';

import './styles.scss';

interface Props {
    id: string;
    checked: boolean;
    children: ReactNode;
    hasError?: boolean;
    className?: string;
    onChange: (id: string, checked: boolean) => void;
}

export const CheckboxWithContent = ({ id, checked, hasError, children, className = '', onChange }: Props) => {
    const changeHandler = (e: ChangeEvent<HTMLInputElement>) => onChange(id, e.target.checked);
    return (
        <div className={`checkbox-with-content ${className}`}>
            <input type='checkbox' id={id} checked={checked} onChange={changeHandler} />
            <label className={`${hasError ? 'has-error' : ''}`} htmlFor={id}>
                <span className='checkbox-with-content__checkbox-icon'></span>
                {children}
            </label>
        </div>
    );
};
